import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { RequireAuth } from './contexts/AuthContext';
import { features } from './lib/features';
import LoginPage from './pages/Login';
import RegisterPage from './pages/Register';
import WelcomePage from './pages/Welcome';
import QueuePage from './pages/Queue';
import ReaderPage from './pages/Reader';
import LibraryPage from './pages/Library';
import DiscoverPage from './pages/Discover';
import SettingsPage from './pages/Settings';
import AdminPage from './pages/Admin';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/" element={<Navigate to="/queue" replace />} />
          <Route path="/welcome" element={<RequireAuth><WelcomePage /></RequireAuth>} />
          <Route path="/queue" element={<RequireAuth><QueuePage /></RequireAuth>} />
          <Route path="/queue/:id" element={<RequireAuth><QueuePage /></RequireAuth>} />
          <Route path="/reader/:id" element={<RequireAuth><ReaderPage /></RequireAuth>} />
          <Route path="/library" element={<RequireAuth><LibraryPage /></RequireAuth>} />
          {features.discover && (
            <Route path="/discover" element={<RequireAuth><DiscoverPage /></RequireAuth>} />
          )}
          <Route path="/settings" element={<RequireAuth><SettingsPage /></RequireAuth>} />
          <Route path="/admin" element={<RequireAuth><AdminPage /></RequireAuth>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
